import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./VideoSection.css";
import { LanguageContext } from "../../context/LanguageContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VideoSection = () => {
  const { currentLang } = useContext(LanguageContext);
  const [data, setData] = useState(null);

  const resolveUrl = (u) =>
    !u ? "" : u.startsWith("http") ? u : `${API_BASE}${u}`;

  // ============================================================
  // FETCH VIDEO SECTION (DYNAMIC)
  // ============================================================
  useEffect(() => {
    const fetchVideoSection = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/VideoSection?lang=${currentLang}`
        );
        setData(res.data);
      } catch (err) {
        console.error("Failed to fetch Video Section:", err);
      }
    };

    fetchVideoSection();
  }, [currentLang]);

  if (!data) return null;

  return (
    <section
      className="video-section"
      style={{ direction: "ltr" }} // <- për këtë seksion gjithmonë ltr si Experienca
    >
      {/* BACKGROUND VIDEO */}
      {data.video && (
        <video className="video-bg" autoPlay muted loop playsInline>
          <source src={resolveUrl(data.video)} type="video/mp4" />
        </video>
      )}

      {/* CONTENT */}
      <div className="video-content">
        <h2>{data.title}</h2>

        <button className="video-btn">{data.button}</button>
      </div>
    </section>
  );
};

export default VideoSection;


// import React from "react";
// import "./VideoSection.css";

// // ===== STATIC VIDEO IMPORT =====
// import bgVideo from "../../assets/videos/videoSection.webm";

// const VideoSection = () => {
//   // ===== STATIC DATA =====
//   const data = {
//     title: "Adapted conditions",
//     button: "Book a Test Drive",
//     video: bgVideo,
//   };

//   return (
//     <section
//       className="video-section"
//       style={{ direction: "ltr" }} // gjithmonë LTR si përvojën
//     >
//       {/* BACKGROUND VIDEO */}
//       {data.video && (
//         <video className="video-bg" autoPlay muted loop playsInline>
//           <source src={data.video} type="video/mp4" />
//         </video>
//       )}

//       {/* CONTENT */}
//       <div className="video-content">
//         <h2>{data.title}</h2>

//         <button className="video-btn">{data.button}</button>
//       </div>
//     </section>
//   );
// };

// export default VideoSection;

